export default "/images/198c95f2b1021034f1b4e62b0db15162.avif";